<!--欢迎词-->
<template>
  <div style="background-color: #82a9ff;padding: 20px;text-align: center">
    <div style="padding-bottom: 20px;font-size: 30px">欢迎来到 Clem 集团</div>
    <div style="padding-bottom: 10px">我们是由几位年轻热情的资深开发人员组成的团队</div>
    <div style="padding-bottom: 10px"> 我们的重点是做简单但功能强大的应用程序,我们所有的应用程序都是为极简主义而设计的.</div>
  </div>
</template>

<script>
export default {
  name: "MyWelcome"
}
</script>

<style scoped>

</style>
